import React         from 'react';
import filesize      from 'filesize';
import TimeLeft      from './TimeLeft';
import API           from './server_api'



export default function FolderStats(props) {
    let progress = props.stats.uploaded_so_far;

    // прогресс с учетом файлов, которые еще загружаются
    for (let i in props.stats.files) {
        const f = props.stats.files[i];
        if (f.uploading) {
            progress += f.size * f.progress / 100;
        }
    }

    let percentage = 0, elapsed = 0, time_left = 0;
    if (props.stats.uploading_now) {
        // оставшийся процент
        percentage = (100 * (props.stats.total_to_upload - progress) / props.stats.total_to_upload).toFixed(1);
        // оставшееся время (в миллисекундах)
        elapsed = (new Date()).getTime() - props.stats.upload_started.getTime();
        time_left = elapsed / progress * (props.stats.total_to_upload - progress + 1);
    }

    const downloadAll = function (event){
        event.preventDefault();
        console.log(props.linkrefs);
        for (let i in props.linkrefs)
            setTimeout((ref)=>{ref.click()}, i*300, props.linkrefs[i]);
    }
    
    return (<div className="d-flex flex-wrap w-100 justify-content-left my-2">
        
        <small className="mr-3 flex-grow-1">
            { props.stats.files.length > 0 && props.stats.files.length < 6 && !props.stats.uploading_now && 
                <a download href="/#" onClick={downloadAll}>
                    Скачать по одному »
                </a>
            }
            { props.stats.files.length > 3 && !props.stats.uploading_now && 
                <a download href={API.fileDownloadURL(props.stats.id, props.stats.zip_token)}>
                    Скачать все (zip) »
                </a>
            }
        </small>
        <div className="mx-1 text-body">
            {props.stats.uploading_now ?
                <small>
                    <span className="text-secondary"> Загружаем </span>
                    {filesize(props.stats.total_to_upload)}
                    <span className="text-secondary">, осталось </span>
                    {percentage + '%, '}
                    {TimeLeft(time_left)}
                </small> :
                <small>
                    {props.stats.files.length}
                    <span className="text-secondary"> файла(ов), </span>
                    {filesize(props.stats.total_uploaded)}
                </small>}
        </div>
    </div>);
}
